import { createFileRoute } from '@tanstack/react-router'

import { LeaveCalendarPage } from '@/features/leave/pages/LeaveCalendarPage'

export const Route = createFileRoute('/_authenticated/leave/calendar')({
  component: LeaveCalendarPage,
})
